import React from "react";
import GenericTable from "../generic/GenericTable";
import { HistoryItem } from "../../types/InventoryHistory";

interface InventoryHistoryTableProps {
    data: HistoryItem[];
    currentPage: number;
    setCurrentPage: (page: number) => void;
}

const InventoryHistoryTable: React.FC<InventoryHistoryTableProps> = ({ data, currentPage, setCurrentPage }) => {
    // Define table headers
    const headers = [
        "Material Type",
        "Color",
        "Size",
        "Quantity Changed",
        "Remaining Quantity",
        "Unit Price",
        "New Purchase",
        "Created At",
        "Balance",
    ];

    // Transform data for GenericTable
    const tableData = data.map((item) => ({
        "Quantity Changed": `${item.quantity_changed} ${item.quantity_unit}`,
        "Remaining Quantity": `${item.remaining_quantity} ${item.quantity_unit}`,
        "Unit Price":
            item.unit_price !== null && item.unit_price !== undefined
                ? `$${item.unit_price.toFixed(2)}`
                : "N/A",
        "New Purchase": item.is_new ? "Yes" : "No",
        "Created At": item.created_at,
        "Balance": `$${item.balance.toFixed(2)}`,
        "Material Type": item.material_type,
        "Color": `${item.color_name || "N/A"} (${item.color_code || "N/A"})`,
        "Size": item.material_size || "N/A",
    }));

    return (
        <div className="overflow-x-auto">
            {/* Render the GenericTable */}
            <GenericTable columns={headers}
                          data={tableData}
                          currentPage={currentPage}
                          onPageChange={setCurrentPage}/>

        </div>
    );
};

export default InventoryHistoryTable;
